import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-background min-h-screen h-full" }
const _hoisted_2 = { class: "flex flex-col container" }
const _hoisted_3 = { class: "flex flex-row justify-between py-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M11 17l-5-5m0 0l5-5m-5 5h12"
  })
], -1)
const _hoisted_5 = { class: "flex flex-row space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GetTalentEvaluationForm = _resolveComponent("GetTalentEvaluationForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              label: "Back",
              variant: "outlined",
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router && _ctx.router?.push('/talent-evaluation')))
            }, {
              startIcon: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              label: "Edit template",
              variant: "contained",
              onOnClick: _cache[1] || (_cache[1] = () => _ctx.router?.push(`/edit-talent-evaluation?id=${_ctx.id}`))
            })
          ])
        ]),
        _createVNode(_component_GetTalentEvaluationForm)
      ])
    ])
  ], 64))
}